import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
// import formsAavin from "@/pages/Dashboard/aavin/form.vue";
import landing from "@/pages//Dashboard/aavin/landing.vue";
import payment from "@/pages//Dashboard/aavin/payment.vue";
import search from "@/pages//Dashboard/aavin/search.vue";
import usersearch from "@/pages//Dashboard/aavin/user_search.vue";
import preview from "@/pages//Dashboard/aavin/application_preview.vue";
import applicationpreview from "@/pages//Dashboard/aavin/user_app_preview.vue";
import call_letter from "@/pages//Dashboard/aavin/call_letter.vue";
const routes = [
  {
    path: "/",
    redirect: "/landing",
    name: "Home"
  },
  {
    path: "/",
    component: DashboardLayout,
    children: [
      {
        path: "landing",
        name: "Landing",
        components: { default: landing }
      },
      {
        path: "forms",
        name: "landing",
        components: { default: landing }
      },
      {
        path: "preview",
        name: "preview",
        components: { default: preview }
      },
      {
        path: "userapplication",
        name: "userapplication",
        components: { default: applicationpreview }
      },
      {
        path: "payment",
        name: "payment",
        components: { default: payment }
      },
      {
        path: "aavinadminsearch",
        name: "search",
        component: search
      },
      {
        path: "trackapplication",
        name: "trackapplication",
        component: usersearch
      },
      {
        path: "call-letter",
        name: "call-letter",
        component: call_letter
      }
    ]
  }
];

export default routes;
